module.exports = __webpack_public_path__ + "img/artist-02.e901a9da.png";